/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import imgTrial from './images/trial-user.svg';
import imgTrialExpired from './images/trial-user-expired.svg';
import imgSvcpkg from './images/svcpkg-user.svg';
import imgSvcpkgExpired from './images/svcpkg-user-expired.svg';
import imgComm from './images/comm-user.svg';
import imgCommExpired from './images/comm-user-expired.svg';


const propTypes = {
  plan: React.PropTypes.object.isRequired,
};

class BillingAvatar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { plan } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  render() {
    const { plan } = this.state;
    let avatar = (
      <div className={styles.loading}>
        <i className="fa fa-spinner fa-spin" />
      </div>
    );

    if (plan.status === 'success') {
      const { data: { tier, expired } } = plan;
      if (tier === 1 && expired) {
        avatar = <img src={imgTrialExpired} alt="" className="img-responsive" />;
      } else if (tier === 1) {
        avatar = <img src={imgTrial} alt="" className="img-responsive" />;
      } else if (tier === 2 && expired) {
        avatar = <img src={imgSvcpkgExpired} alt="" className="img-responsive" />;
      } else if (tier === 2) {
        avatar = <img src={imgSvcpkg} alt="" className="img-responsive" />;
      } else if (tier === 3 && expired) {
        avatar = <img src={imgCommExpired} alt="" className="img-responsive" />;
      } else {
        avatar = <img src={imgComm} alt="" className="img-responsive" />;
      }
    }

    return (
      <div className={styles.avatar}>
        {avatar}
      </div>
    );
  }
}

BillingAvatar.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
});

export default connect(mapStateToProps, null)(BillingAvatar);




// WEBPACK FOOTER //
// ./src/containers/Overview/BillingAvatar/index.jsx